import styled from 'styled-components';

const StyledHelperText = styled.small`
  font-size: 0.8rem;
  margin-top: 0.5em;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export default StyledHelperText;
